import { defineStore } from "pinia";
import { useSessionStore } from "@/stores/sessionStore";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";
const apiGatewayRepository = RepositoryFactory.get("apiGateway");
import ApplicationError from "@/helpers/applicationError";
import { API_RESPONSE_SUCCESS, HTTP_CODE_SUCCESS } from "@/data/constants";
import i18n from '@/i18n/main'

const { t } = i18n.global;
export const useTransactionStore = defineStore("transactions", {
    id: "transaction",
    state: () => {
        return {
            isLoading: false,
            transactions: [],
            page: 1,
            companyAppId: "",
            dateTo: null,
            dateFrom: null,
            status: null,
            totalPages: null,
            errorMessage: ""
        };
    },
    persist: {
        paths: ["companyAppId", "dateTo", "dateFrom", "status"],
    },
    getters: {
        getUserInfo(state) {
            return useSessionStore().session_data;
        },
    },
    actions: {
        refreshErrorMessage(){
            this.errorMessage = "";
        },
        async getTransactions(page) {
            try {
                this.isLoading = true;
                this.refreshErrorMessage();
                if(!this.validateDates()){
                    this.errorMessage = t('ERROR_DATE_FROM_GREATER_DATE_TO');
                    this.isLoading = false;
                    return false;
                }
                
                let params = {
                    user_id: this.getUserInfo.hubsynch_id,
                    offset: page != null ? (page-1) * process.env.VUE_APP_PAGINATION_LIMIT : 0,
                    limit: process.env.VUE_APP_PAGINATION_LIMIT,
                    app_id: this.companyAppId,
                    from: this.formatDateFrom(this.dateFrom),
                    to: this.formatDateTo(this.dateTo),
                    status: this.status,
                };

                const response = await apiGatewayRepository.getPaymentHistory(params);
                
                if (response.success == API_RESPONSE_SUCCESS && response.code == HTTP_CODE_SUCCESS) {
                    this.transactions = response.data;

                    this.totalPages = response.meta.total != null && response.meta.limit != null ? Math.ceil(response.meta.total / response.meta.limit) : 1;
                }
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                throw new ApplicationError(error.message, {
                    company_app_id: this.companyAppId,
                    date_from: this.dateFrom,
                    date_to: this.dateTo,
                    status: this.status,
                    page: page
                }, error)
            }
        },
        formatDateFrom(inputDate) {
            let result = null;
            if (inputDate != undefined && inputDate != null) {
                const date = new Date(inputDate);
                const year = date.getFullYear();
                const month = ("0" + (date.getMonth() + 1)).slice(-2);
                const day = ("0" + date.getDate()).slice(-2);
                result = `${year}-${month}-${day} 00:00:00`;
            }
            return result;
        },
        formatDateTo(inputDate) {
            let result = null;
            if (inputDate != undefined && inputDate != null) {
                const date = new Date(inputDate);
                const year = date.getFullYear();
                const month = ("0" + (date.getMonth() + 1)).slice(-2);
                const day = ("0" + date.getDate()).slice(-2);
                result = `${year}-${month}-${day} 23:59:59`;
            }
            return result;
        },
        validateDates(){
            var result = true;
            if(this.dateFrom != null && this.dateTo !=null && this.dateFrom > this.dateTo){
                result = false;
            }
            return result;
        },
    },
});
